module.exports = __webpack_public_path__ + "static/img/wanfang.ad9dfd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/wanfang.png
// module id = mV2m
// module chunks = 3